import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { CreateGadgetComponentComponent } from './create-gadget-component.component';
import { PhotoSelectorModule } from '../photo-selector/photo-selector.component.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';


@NgModule({
  declarations: [CreateGadgetComponentComponent],
  imports: [
    CommonModule,
    SharedModule,
    PhotoSelectorModule,
    IonicModule,
  ],
  exports:[CreateGadgetComponentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CreateGadgetComponentModule { }
